import * as React from 'react'

import Svg, { Path } from 'react-native-svg'

import { IconProps } from '../icons'

const ArrowTop = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.74 14.734a.88.88 0 0 1-1.26 0L12 11.191l-3.48 3.543a.88.88 0 0 1-1.26 0 .92.92 0 0 1 0-1.283l4.11-4.185a.88.88 0 0 1 1.26 0l4.11 4.185a.92.92 0 0 1 0 1.283Z"
      fill={color}
    />
  </Svg>
)

export default ArrowTop
